import IconChevronRight from '@apollo/icons/default/IconChevronRight.svg';
import { IconButton } from '@apollo/orbit';
import * as React from 'react';
import { useState } from 'react';

export interface HeaderTableProps {
  className?: string;
  title: string;
  headers: Array<{ key: string; value: string }>;
}

export const HeaderTable = ({
  className,
  title,
  headers,
}: HeaderTableProps) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className={className}>
      <div className="flex justify-between">
        <h2 className="text-lg font-semibold">{title}</h2>
        <IconButton
          aria-label={collapsed ? 'Expand' : 'Collapse'}
          variant="hidden"
          size="sm"
          icon={
            <IconChevronRight
              className={collapsed ? 'rotate-0' : 'rotate-90'}
            />
          }
          onClick={() => {
            setCollapsed(!collapsed);
          }}
        />
      </div>
      {!collapsed && (
        <table className="mt-2 border-collapse font-mono text-sm">
          <tbody>
            {headers.map(({ key, value }) => (
              <tr key={key}>
                <td className="py-2">
                  <span className="rounded bg-silver-light p-1 font-semibold text-secondary">
                    {key}
                  </span>
                </td>
                <td className="pl-1 text-placeholder">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
